import {
  initialState,
  Actions,
  State,
  GET_INSPECTIONS_METRICS,
  GET_INSPECTIONS_METRICS_SUCCESS,
  GET_INSPECTIONS_METRICS_ERROR,
  RESET_GET_INSPECTIONS_METRICS,
} from '../../types/inspection/get-metrics'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_INSPECTIONS_METRICS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_INSPECTIONS_METRICS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_INSPECTIONS_METRICS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_INSPECTIONS_METRICS:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
